import React from 'react';
import LateralMenu from '../LateralMenu';
import { translate } from '../../services/translate';
import logo from '../../../assets/logo_armory.png';
import collapsedLogo from '../../../assets/icon_armory.png';
import { faClipboardListCheck, faClock } from '@fortawesome/pro-regular-svg-icons';

export default function ArmoryLateralMenu({ navigation, authenticatedUser, open, setOpen, selectedMenu }: LateralMenuProps) {
    const items = [];

    if (authenticatedUser?.permissions.armory_manage_armory_shift ||
        authenticatedUser?.permissions.armory_manage_acting_body_units_armory_shift ||
        authenticatedUser?.permissions.armory_manage_all_acting_bodies_armory_shift ||
        authenticatedUser?.permissions.armory_replace_in_charge_armourer
    ) {
        items.push({
            icon: faClock,
            text: translate('manageShifts'),
            action: () => navigation.navigate('Armory', { screen: 'ArmoryShifts' }),
            selected: selectedMenu == 'armory-shifts'
        });
    }

    if (authenticatedUser?.permissions.armory_assigned_as_armourer) {
        items.push({
            icon: faClipboardListCheck,
            text: translate('myShifts'),
            action: () => navigation.navigate('Armory', { screen: 'MyArmoryShifts' }),
            selected: selectedMenu == 'my-armory-shifts'
        });
    }

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            setOpen={setOpen}
            items={items}
            open={open}
            authenticatedUser={authenticatedUser}
        />
    );
}
